import type React from "react";
import { type ReactNode } from "react";
import { useMediaDataRoomVersionedValue } from "features/mediaDataRoom/contexts";

type VersionBuilder =
  | ReactNode
  | ((props: React.PropsWithChildren<{ [key: string]: unknown }>) => ReactNode);

type MediaDataRoomVersionSwitchProps = React.PropsWithChildren<{
  ab: VersionBuilder;
  v3: VersionBuilder;
}>;

const MediaDataRoomVersionSwitch: React.FC<MediaDataRoomVersionSwitchProps> = ({
  ab,
  v3,
  children,
  ...restProps
}) =>
  useMediaDataRoomVersionedValue({
    ab: typeof ab === "function" ? ab({ ...restProps, children }) : ab,
    v3: typeof v3 === "function" ? v3({ ...restProps, children }) : v3,
  });
MediaDataRoomVersionSwitch.displayName = "MediaDataRoomVersionSwitch";

export default MediaDataRoomVersionSwitch;
